module.exports = __webpack_public_path__ + "static/TheRabbit-2cd75b0492d0e8e12e585937fd6fcc04.jpg";